const input = document.querySelector<HTMLInputElement>('[data-glossary-search]');
const terms = [...document.querySelectorAll<HTMLElement>('[data-term]')];
const count = document.querySelector<HTMLElement>('[data-glossary-count]');

function filterTerms() {
  const query = input?.value.trim().toLocaleLowerCase() || '';
  let visible = 0;
  for (const term of terms) {
    const matches = !query || (term.textContent || '').toLocaleLowerCase().includes(query);
    term.hidden = !matches;
    if (matches) visible += 1;
  }
  if (count) count.textContent = `${visible} of ${terms.length} terms`;
}

input?.addEventListener('input', filterTerms);
filterTerms();
